import React, { useState } from 'react';
import './ChatScreen.css';
import Avatar from '@material-ui/core/Avatar';

const ChatScreen = () => {

    const [input, setInput] = useState('');
    const [messages, setMessages] = useState([
        {
            name: "lina",
            image: "https://halcyonhouse.org/sites/default/files/images/people/lz339_33.jpg",
            message: "hello guys "
        },
        {
            name: "lina",
            image: "https://halcyonhouse.org/sites/default/files/images/people/lz339_33.jpg",
            message: "How its going!"
        },
        {
            message: "Fine..how r u ?"
        },

    ]);

    const handleClick = (e) => {
        e.preventDefault();
        setMessages([...messages, { message: input }])
        setInput("");
    }

    return (
        <div className='chatScreen'>
            <p className='chatScreen_timestamp'>You match with lina 10/10/2020</p>
            {messages.map(message => (
                message.name ? (
                    <div className='chatScreen_message'>
                        <Avatar
                            alt={message.name}
                            src={message.image}
                        />
                        <p className='chatScreen_text'>{message.message}</p>
                    </div>
                ) : (
                        <div className='chatScreen_message'>
                            <p className='chatScreen_textUser'>{message.message}</p>
                        </div>
                    )

            ))}
            <div >
                <form className='chatScreen_input'>
                    <input type='text'
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        className='chatScreen_inputField'
                        placeholder='Type a Message...' />
                    <button
                        onClick={handleClick}
                        type='submit'
                        className='chatScreen_inputButton'>SEND</button>
                </form>
            </div>
        </div>
    )
}

export default ChatScreen;
